<template>
    <div class="animated fadeIn">

        <b-container class="w-100 px-0">

            <v-client-table
                ref="unsubscribeTable"
                :columns="columns"
                :data="activity"
                :options="options"
                :theme="theme"
                class="dataTable" md="12" lg="12" sm="12">

                <template slot="date" slot-scope="props">
                    {{ props.row.date | dateFormat('DD/MM/YYYY HH:mm') }}
                </template>

            </v-client-table>

        </b-container>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {ClientTable} from 'vue-tables-2';
    import form from '@/helpers/form';

    Vue.use(ClientTable);

    export default {
        name: 'partnerActivity',
        props: ['activity'],
        data: function () {
            return {
                columns: ['type', 'date', 'username', 'description'],
                theme: 'bootstrap4',
                options: {
                    headings: {
                        type: 'Tipo',
                        date: 'Fecha',
                        username: 'Usuario',
                        description: 'Descripción'
                    },
                    sortable: [],
                    filterable: ['type', 'date','username', 'description'],
                    sortIcon: {base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort'},
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
            }
        },
        mounted() {
            this.options.texts = form.tableLabels();
        }
    }
</script>